import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axios";

const initialState = {
  cars: [],
  loading: false,
  getCartData: [],
  selectedCar: null,
  error: null,
  filterCarsData: {},
  isFiltered: false,
  dateTimeInteraction: false,
  getMyCarsData: [],

  carCategoryId: "",

  OrdersData: [],
  fetchFiltersResp:{},
  getBannerData: [],
  deleteCarResponse: false,
  OrdersStatus: "",
  postRatingResponse: {},
  searchQuery: {},
};

const config = {
  headers: {
    key: "KwachaRides-api-secret-key",
  },
};

export const getBanners = createAsyncThunk("getBanners", async (info) => {
  try {
    const response = await axios.get(`/banner/getBanners`, config);
    return response?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const getAllCars = createAsyncThunk("cars    ", async () => {
  try {
    const response = await axios.get("/car/getAllcars", config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const getmycars = createAsyncThunk("getmycars", async (info) => {
  try {
    const response = await axios.post(
      `/signupuser/getmycars`,
      { userId: info?.userId },
      config
    );
    return response?.data?.data?.cars;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const completeBookingByOwner = createAsyncThunk(
  "completeBookingByOwner",
  async (info) => {
    try {
      const response = await axios.post(`/booking/completeBookingByOwner`, {
        bookingId: info?.bookingId,
      });
      return response?.data;
    } catch (error) {
      return error.response.data.errors;
    }
  }
);

export const fetchOrders = createAsyncThunk("fetchOrders", async (info) => {
  try {
    const response = await axios.post(
      `/booking/fetchOrders`,
      { userId: info?.userId },
      config
    );
    return response?.data?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});
export const fetchNotification = createAsyncThunk("fetchNotification", async (data) => {
  try {
    const response = await axios.post(
      `/car/fetchnotification`,
      data,
      config
    );
    return response?.data?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const deleteCar = createAsyncThunk("deleteCar", async (info) => {
  try {
    const response = await axios.post(
      `/car/deleteCar`,
      { carId: info?.carId },
      config
    );
    return response?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const getCars = createAsyncThunk("getCars", async () => {
  try {
    const response = await axios.get(
      `/car/getCars?categoryId=6614543c52681111d64b5b8f`,
      config
    );
    return response?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});
export const fetchFilters = createAsyncThunk("fetchFilters", async () => {
  try {
    const response = await axios.get(
      `/car/fetchFilters`,
      config
    );
    return response?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const addCars = createAsyncThunk("addCars", async (data) => {
  const response = await axios.post(`/car/createCar`, data, config);
  return response?.data;
});
export const filterCars = createAsyncThunk("filterCars", async (data) => {
  console.log("data 1452", data);
  const response = await axios.post(`/car/filtercars`, data, config);
  return response?.data;
});
export const postRatings = createAsyncThunk("postRatings", async (data) => {
  const response = await axios.post(`car/postratings`, data, config);
  return response?.data;
});

const carSlice = createSlice({
  name: "car",
  initialState,
  reducers: {
    setSelectedCar: (state, action) => {
      state = action.payload;
    },

    setCarCategoryId: (state, action) => {
      state.carCategoryId = action.payload;
    },
    clearCarCategoryId: (state) => {
      state.carCategoryId = "";
    },
    cleanCarDelete(state) {
      state.deleteCarResponse = {};
    },
    cleanOrdersStatus(state) {
      state.OrdersStatus = "";
    },
    cleanPostRatingResponse(state) {
      state.postRatingResponse = {};
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearchQuery: (state, action) => {
      state.isFiltered = false;
      state.searchQuery = {};
    },
    setDateTimeInteraction: (state) => {
      state.dateTimeInteraction = true;
    },
    resetDateTimeInteraction: (state) => {
      state.dateTimeInteraction = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCars.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCars.fulfilled, (state, action) => {
        state.loading = false;
        state.getCartData = action.payload;
        state.isFiltered = false;
        state.searchQuery = {}; // search bar query value's will reset also
        state.error = null;
      })
      .addCase(getAllCars.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(filterCars.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(filterCars.fulfilled, (state, action) => {
        state.loading = false;
        // state.filterCarsData = action.payload;
        state.getCartData = action.payload;
        state.isFiltered = true;
      })
      .addCase(filterCars.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchFilters.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchFilters.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchFiltersResp = action.payload;
      })
      .addCase(fetchFilters.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getmycars.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getmycars.fulfilled, (state, action) => {
        state.loading = false;
        state.getMyCarsData = action.payload;
        state.error = null;
      })
      .addCase(getmycars.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(completeBookingByOwner.fulfilled, (state, action) => {
        state.OrdersStatus = action.payload;
      })
      .addCase(fetchOrders.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.OrdersData = action.payload;
        state.error = null;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBanners.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.getBannerData = action.payload;
        state.error = null;
      })
      .addCase(getBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCar.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCar.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteCarResponse = action.payload;
        state.error = null;
      })
      .addCase(deleteCar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(postRatings.fulfilled, (state, action) => {
        state.postRatingResponse = action?.payload;
      })
      .addCase(postRatings.rejected, (state, action) => {
        state.postRatingResponse = action?.payload;
      });
  },
});

export const {
  setSelectedCar,
  setCarCategoryId,
  clearCarCategoryId,
  cleanPostRatingResponse,
  cleanCarDelete,
  cleanOrdersStatus,
  setSearchQuery,
  clearSearchQuery,
  setDateTimeInteraction,
  resetDateTimeInteraction,
} = carSlice.actions;

export default carSlice.reducer;
